import React from "react";
import "./NoLandAvailable.css";

function NoLandAvailable() {
  return (
    <div>
      <div className="no-land">
        <div className="no-land-content">
          <div className="no-land-img">
            <img
              src="\assets\images\Market Place images\NoLandAvailable.png"
              alt=""
              className="img-fluid"
            />
          </div>
          <p className="heading mt-5">
            OPPS. Due to High demand. <br /> No Land available for rent.
          </p>
          <div className="para-1">
            <p>Want to Rent a Land?</p>
          </div>
          <div className="btn">
            <button>Register Interest in Rent</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoLandAvailable;
